import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import RequirePassword from "@/common/customer.additional-data-fields/RequirePassword";
import SaveButton from "@/common/customer.additional-data-fields/SaveButton";
import { getPlatform } from "@/hooks";

const { Customer, UI } = Mobi2Go;
const { requestOptIn } = Customer.SpoonityLoyalty;

const Spoonity = ({ baseClass, closeModal }) => {
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const [t] = useTranslation('loyalty');
    const successMessageTimeout = 8000;

    useEffect(() => {
        if (isSuccess) {
            const successTimer = setTimeout(() => {
                Customer.trigger('updateLoyalty');

                if (getPlatform() === 'web') {
                    closeModal();
                } else {
                    UI.trigger('showOrderEditor');
                }
            }, successMessageTimeout);

            return () => {
                clearTimeout(successTimer);
                Customer.trigger('updateLoyalty');
            }
        }
    }, [isSuccess])

    const onSave = async () => {
        setIsLoading(true);

        try {
            const result = await requestOptIn(password);

            setIsLoading(false);

            if (result) {
                setIsSuccess(true);
            }
        } catch (err) {
            setIsLoading(false);
            setPassword('');

            throw err;
        }
    }

    return (
        <>
            <RequirePassword
                password={password}
                handleChange={setPassword}
                baseClass={baseClass}
                isRefreshing={isLoading}
                promptText={isSuccess ? '' : t('opt_in_confirmation')}
                savingText={t('opt_in_saving')}
                policyLink={isSuccess ? '' : t('opt_in_confirmation_link')}
                isSuccess={isSuccess}
                closeModal={closeModal}
            />

            <SaveButton
                handleSave={onSave}
                text={t('opt_in_button')}
                baseClass={baseClass}
                saveButtonDisabled={!password || isLoading || isSuccess}
            />
        </>
    );
}

export default Spoonity;
